<template>
  <el-switch
    v-bind="$attrs"
    class="rt-switch"
    v-on="$listeners"
  />
</template>

<script>
export default {
  name: 'RtSwitch'
}
</script>



// WEBPACK FOOTER //
// rtSwitch.vue?f165e76a